import React from 'react';
import { useData } from '../context/DataContext';

interface FilterBarProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

export function FilterBar({ selectedCategory, onCategoryChange }: FilterBarProps) {
  const { settings } = useData();
  const categories = ['Tout', ...(settings.categories || [])];

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-3 rounded-lg text-sm font-bold transition-all duration-200 transform hover:scale-105
            ${selectedCategory === category
              ? 'bg-red-600 text-white shadow-lg shadow-red-500/30'
              : 'bg-gray-900 text-gray-100 hover:bg-gray-800'
            }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}